import { createSelector } from 'reselect'
import { AppState } from 'store/store'

//#region Templates

/**
 *
 * @param state - the application state
 * @returns data - the current properties reducer
 */
export const selectCurrentPropertiesReducer = (state: AppState) => state.properties

/**
 * Gets the properties' array from the properties reducer
 */
export const selectCurrentProperties = createSelector(
  selectCurrentPropertiesReducer,
  (properties) => properties.data
)
/**
 * Gets the properties' meta from the properties reducer
 */
export const selectCurrentPropertiesMeta = createSelector(
  selectCurrentPropertiesReducer,
  (properties) => properties.meta
)
/**
 * Gets the properties' isFetching from the properties reducer
 */
export const selectCurrentPropertiesFetching = createSelector(
  selectCurrentPropertiesReducer,
  (properties) => properties.isFetching
)
//#endregion
